import { Application, ConnectorRegistry, SimplifiedRegistry } from '../Application';

export function bootstrapTerrific(
	$page : JQuery,
	modules : SimplifiedRegistry,
	debug = false,
	connectors? : ConnectorRegistry,
) : Application {
	const app = new Application(
		$page,
		{
			debug,
		},
		modules,
		connectors,
	);

	return app;
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/vendor/terrific/utils/bootstrap.ts